import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Thumbs, Controller } from "swiper";

import { testimonial_2, testimonial_2_nav } from "../../../data";

const TestimonialThree = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  return (
    <>
      <section className="testimonial__area pt-145 pb-150" style={{ background: `url(/assets/img/testimonial/home-3/testimonial-bg-3.jpg)`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-10">
              <div className="testimonial__slider-3">
                <h3 className="testimonial__title">O que nossos alunos têm a dizer!</h3>
                <div className="testimonial__slider-wrapper swiper-container testimonial-text mb-35">

                  <Swiper
                    thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                    loop={true}
                    spaceBetween={0}
                    slidesPerView={1}
                    freeMode={false}
                    watchSlidesProgress={true}
                    modules={[Controller, FreeMode, Thumbs]}
                  >
                    {testimonial_2.map((item, index) => {
                      return (
                        <SwiperSlide key={index}>
                          <div className="testimonial__item-3">
                            <p>{item.desc}</p>
                            <div className="testimonial__info-2">
                              <h4>{item.name}</h4>
                              <span>{item.subtitle}</span>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    })
                    }
                  </Swiper>
                </div>

                <div className="swiper-container testimonial-nav">
                  <Swiper
                    loop={true}
                    spaceBetween={0}
                    slidesPerView={3}
                    onSwiper={setThumbsSwiper}
                    modules={[Controller, FreeMode, Thumbs]}
                    watchSlidesProgress={false}
                  >
                    {testimonial_2_nav.map((item, index) => (
                      <SwiperSlide key={index}>
                          <div className="testimonial__nav-thumb">
                            <img src={item.img} alt="" />
                          </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>

                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-10">
              
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialThree;